import { HailIcon } from './HailIcon';

/**
 * author: Google
 * id B4AC04DD-9F29-4F55-ABB6-A4AE4F272EC4
 * name hail
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/hail.svg
 * tags
 * - Transportation + Road 
 * - Navigation 
 */
export const HailTaxiIcon = HailIcon;
export default HailTaxiIcon